const fr = {
  // Navigation
  nav_plan: 'Planifier',
  nav_itinerary: 'Itinéraire',
  nav_saved: 'Sauvegardé',

  // Header
  explore_photos: 'Explorer les photos',
  sign_in: 'Se connecter',

  // Plan screen
  new_trip: '+ Nouveau voyage',
  add_city_header: 'Ajouter une ville',
  city_placeholder: 'Entrer le nom d\'une ville…',
  add_cities_empty: 'Ajouter des villes pour commencer à planifier',
  dest_bangkok: 'Bangkok', dest_paris: 'Paris', dest_london: 'Londres', dest_dubai: 'Dubaï',
  dest_singapore: 'Singapour', dest_tokyo: 'Tokyo', dest_new_york: 'New York',
  dest_istanbul: 'Istanbul', dest_kuala_lumpur: 'Kuala Lumpur', dest_seoul: 'Séoul',
  hero_badge: 'Planification de voyage par IA',
  hero_title_line1: 'Votre prochain voyage,',
  hero_title_line2: 'parfaitement planifié.',
  hero_subtitle: 'Appuyez sur une destination pour planifier instantanément',
  most_visited_label: 'Destinations les plus visitées',
  popular_destinations: 'Destinations populaires',
  or_type_your_own: 'ou saisissez la vôtre',
  where_going_label: 'Où allez-vous ?',
  expanding_region: (r) => `Recherche des meilleures villes de ${r}…`,
  tap_to_explore: '— appuyez pour explorer',
  attraction_count: (n) => `${n} ${n === 1 ? 'attraction' : 'attractions'}`,
  show_less: 'Voir moins',
  read_more: 'Lire la suite',
  more: 'Plus',
  less: 'Moins',
  no_attractions: 'Aucune attraction ajoutée',
  add_attraction_placeholder: (city) => `Ajouter une attraction à ${city}…`,
  auto_add_title: 'Ajouter automatiquement les attractions recommandées',
  preferences_label: 'Intérêts',
  all_types_label: 'Tous les types',
  edit_interests: 'Modifier les intérêts…',
  plan_framing_msg: 'Garde ce que tu aimes, supprime le reste — puis génère ton plan jour par jour.',
  add_back: 'Restaurer',
  added_label: 'Ajouté',
  refresh_attractions: 'Actualiser les attractions',
  plan_multi_summary: (n, m) => `${n} ${n === 1 ? 'ville' : 'villes'} · ${m} ${m === 1 ? 'lieu' : 'lieux'}`,
  filter_onboarding_msg: 'Personnalisez vos attractions',
  filter_onboarding_sub: 'Appuyez sur un type pour affiner — nous regenerons avec ce filtre.',
  explore_nearby: 'Explorer les environs',
  explore_nearby_sub: 'Parcourez les photos des incontournables de votre voyage',
  finding_attractions: 'Recherche des attractions…',
  finding_attractions_1: 'Consultation de l\'IA…',
  finding_attractions_2: 'Recherche des incontournables…',
  finding_attractions_3: 'Presque prêt…',
  generating_msg_1: 'Planification de vos journées…',
  generating_msg_2: 'Recherche des meilleurs endroits…',
  generating_msg_3: 'Création de votre itinéraire…',
  view_itinerary: 'Voir l\'itinéraire',
  generate_itinerary: 'Créer l\'itinéraire',
  filterLabel: (label) => ({ 'All': 'Tout', 'Culture': 'Culture', 'Nature': 'Nature', 'Entertainment': 'Divertissement', 'Shopping': 'Shopping', 'Food & Drink': 'Gastronomie', 'Kids': 'Enfants', 'Seniors': 'Séniors' })[label] ?? label,

  // Itinerary screen
  rename: 'Renommer',
  days: (n) => `${n} ${n === 1 ? 'jour' : 'jours'}`,
  unsaved_dot: 'Modifications non sauvegardées',
  share_itinerary: 'Partager l\'itinéraire',
  copy: 'Copier',
  copied: 'Copié !',
  add_more_attractions: 'Ajouter des attractions',
  search_city_placeholder: 'Rechercher une ville…',
  plus_city: '+ Ville',
  your_cities: 'Vos villes',
  unscheduled_count: (n) => `Attractions non planifiées (${n})`,
  drag_to_schedule: 'Glissez vers un jour pour planifier',
  loading_details: 'Chargement des détails…',
  drag_here: 'Glisser une attraction ici',
  day_label: (n) => `Jour ${n}`,
  activity_count: (n) => `${n} ${n === 1 ? 'activité' : 'activités'}`,
  add_note: '+ Ajouter une note',
  note_placeholder: 'Notes pour cette journée — hôtel, déjeuner, rappels…',
  save_note: 'Sauvegarder la note',
  cancel: 'Annuler',
  continue_in_city: 'Continuer dans une ville existante',
  change_back: '← Modifier',
  save: 'Sauvegarder',
  hotel_nights_label: 'Nuits',
  hotel_name_label: 'Nom de l\'hôtel',
  restaurant_label: 'Restaurant (optionnel)',
  search_hotel: 'Rechercher un hôtel…',
  search_restaurant: 'Rechercher un restaurant…',
  searching: 'Recherche en cours…',
  address_label: 'Adresse',
  time_label: 'Heure',
  duration_label: 'Durée',
  notes_label: 'Notes',
  time_placeholder: 'ex. 9h00',
  duration_placeholder: 'ex. 2 heures',
  notes_placeholder: 'ex. check-in à 15h, chambre avec vue sur la piscine…',
  drag_to_reorder: 'Glisser pour réorganiser',
  details: 'Détails',
  edit: 'Modifier',
  snip: 'Snip',
  remove: 'Supprimer',
  move_to_day_picker: 'Déplacer au jour…',
  trip_start_date: 'Départ',
  itinerary_photo_sub: 'Suggestions IA basées sur vos villes',
  itinerary_photo_cta: 'Découvrez les pépites de votre voyage',
  hotel: 'Hôtel',
  meal_at: (restaurant) => `chez ${restaurant}`,
  add_day: 'Ajouter un jour',
  save_changes: 'Enregistrer les modifications',
  saved_check: 'Enregistré ✓',
  save_itinerary: 'Sauvegarder l\'itinéraire',
  print_export: '🖨️ Imprimer / Exporter en PDF',
  photos_details: 'Photos & détails',

  // Saved screen
  snip_requires_account: 'Créez un compte gratuit pour sauvegarder vos favoris',
  sign_in_to_save:'Connectez-vous pour sauvegarder et consulter vos voyages',
  sign_in_or_create: 'Se connecter ou créer un compte',
  snips: 'Snips',
  place_count: (n) => `${n} ${n === 1 ? 'lieu' : 'lieux'}`,
  trips: 'Voyages',
  loading_trips: 'Chargement des voyages…',
  no_saved_trips: 'Aucun voyage sauvegardé',
  add_to_plan: 'Ajouter au plan',
  add_to_itinerary_btn: 'Ajouter à l\'itinéraire',
  untitled_trip: 'Voyage sans titre',
  open: 'Ouvrir',

  // User menu
  signed_in_as: 'Connecté en tant que',
  change_password: 'Changer le mot de passe',
  delete_user_menu: 'Supprimer l\'utilisateur',
  sign_out: 'Se déconnecter',

  // Load saved trip confirmation
  load_trip_confirm_title: 'Ouvrir le voyage sauvegardé ?',
  load_trip_confirm_msg: 'Votre plan actuel sera supprimé. Sauvegardez-le d\'abord si vous souhaitez le conserver.',

  // New trip confirmation
  unsaved_changes_title: 'Modifications non sauvegardées',
  unsaved_changes_msg: 'Votre voyage actuel a des modifications non sauvegardées. Commencer un nouveau voyage quand même ?',
  discard_start_new: 'Ignorer et nouveau voyage',
  new_trip_tab_title: 'Commencer un nouveau voyage ?',
  new_trip_tab_msg: 'Votre itinéraire actuel sera effacé. Sauvegardez-le d\'abord si vous souhaitez le conserver.',
  start_fresh: 'Repartir de zéro',

  // Auth modal
  create_account: 'Créer un compte',
  email_placeholder: 'E-mail',
  password_placeholder: 'Mot de passe',
  i_agree_to: 'J\'accepte les',
  terms_of_service: 'Conditions d\'utilisation',
  privacy_policy: 'Politique de confidentialité',
  and: 'et la',
  no_account: 'Pas encore de compte ? ',
  have_account: 'Déjà un compte ? ',
  network_error: 'Erreur réseau, veuillez réessayer',
  err_email_exists: 'Un compte avec cette adresse e-mail existe déjà',
  err_invalid_credentials: 'E-mail ou mot de passe incorrect',
  err_email_password_required: 'L\'e-mail et le mot de passe sont requis',
  err_password_too_short: 'Le mot de passe doit comporter au moins 6 caractères',

  // Change password modal
  select_user: 'Sélectionner un utilisateur…',
  new_password_placeholder: 'Nouveau mot de passe (6 caractères min.)',
  update_password: 'Mettre à jour le mot de passe',
  password_updated: 'Mot de passe mis à jour',
  select_a_user: 'Sélectionner un utilisateur',
  network_error_short: 'Erreur réseau',

  // Delete user modal
  delete_user_trips: 'Supprimer l\'utilisateur et les voyages',
  deleted_user: (email) => `${email} supprimé`,

  // Photo mode
  photo_loading_msg_1: 'Recherche de lieux magnifiques…',
  photo_loading_msg_2: 'Vérification des photos et détails…',
  photo_loading_msg_3: 'Presque prêt…',
  finding_places: 'Recherche de lieux pour vous…',
  could_not_load_places: 'Impossible de charger les lieux',
  no_places: 'Aucun lieu à afficher',
  ai_error: 'Problème avec l\'IA. Réessayez dans un instant.',
  add_cities_suggestions: 'Ajoutez des villes ou épinglez des lieux pour des suggestions personnalisées.',
  retry: 'Réessayer',
  close: 'Fermer',
  finding_more_places: 'Recherche de nouveaux lieux…',
  seen_it_all: 'Vous avez tout vu !',
  photo_limit_msg: 'Vous avez atteint la limite de 50 lieux pour cette session.',
  check_snips: 'Consultez vos Snips pour revoir les lieux sauvegardés',
  photo_unavailable: 'Photo non disponible',
  loading: 'Chargement…',
  skip: 'Passer',
  plus_itinerary: '+ Itinéraire',
  plus_plan: '+ Plan',
  photo_explore_title: 'Explorer en photos',
  photo_explore_sub: 'Découvrez des lieux visuellement',
  swipe_lr: 'Glissez à gauche ou à droite pour passer',
  swipe_up: 'Glissez vers le haut pour passer',
  lets_go: 'C\'est parti',
  tutorial_skip_desc: 'Passer ce lieu',
  tutorial_snip_desc: 'Enregistrer dans vos Snips pour y revenir plus tard',
  tutorial_add_plan_desc: 'Ajouter à votre onglet Plan',
  tutorial_add_itinerary_desc: 'Ajouter directement à votre itinéraire actuel',
  tutorial_swipe_hint: 'Vous pouvez aussi glisser à gauche, droite ou vers le haut pour passer',

  // Footer
  copyright: '© 2026 Pazzie Inc.',
  terms: 'Conditions',
  privacy: 'Confidentialité',
  sample_itineraries: "Exemples d'itinéraires",
  browse_all_itineraries: 'Voir tout →',

  // Legal overlay
  back_to_app: '← Retour à SnipTrip',

  // Error boundary
  something_wrong: 'Une erreur s\'est produite',
  reload: 'Recharger',

  // Print view
  copy_text: 'Copier le texte',
  copied_check: '✓ Copié',

  // Logic / computed strings
  copy_of: (name) => `Copie de ${name}`,
  transportation: 'Transport',
  meal: 'Repas',

  // Chat mode
  chat_mode_link: 'ou planifier avec l\'IA',
  chat_back: '← Retour à la vue Build',
  chat_input_placeholder: 'Message…',
  chat_error: 'Une erreur est survenue. Réessayer ?',
  chat_cities_count: (n) => n === 1 ? '1 ville' : `${n} villes`,
  chat_places_count: (n) => n === 1 ? '1 lieu' : `${n} lieux`,
  chat_no_cities: 'Aucune ville ajoutée',

  // Discovery panels
  thinking_where: 'Je réfléchis à où vous emmener…',
  couldnt_load_suggestions: 'Impossible de charger les suggestions. Réessayer ?',
  back: '← Retour',
  no_new_suggestions: 'Aucune nouvelle suggestion — essayez une autre question.',
  back_to_questions: '← Retour aux questions',
  dismiss: 'Ignorer',
  where_to_next_header: 'Où aller ensuite ?',
  describe_place: 'Décrivez le type de lieu…',
  go: 'Aller',
  finding_ideas: 'Recherche d\'idées…',
  more_attractions: 'Plus d\'attractions…',
  different_angle: 'Ou explorer sous un autre angle :',
  mood_for: 'Qu\'avez-vous envie de faire ?',
  back_questions_short: '← Questions',
  describe_looking_for: 'Décrivez ce que vous cherchez…',
  where_to_next_trigger: (city) => city ? `+ Où aller après ${city} ?` : '+ Où aller ensuite ?',
  what_else_trigger: (city) => `+ Que devrais-je ajouter près de ${city} ?`,
  day_chip_add_attraction: 'Ajouter une attraction',
  day_chip_add_city: 'Ajouter une ville proche',
  auto_populate_prompt: (city) => `Suggérer des attractions populaires pour ${city} ?`,
  auto_populate_yes: 'Oui, suggérer',
  auto_populate_no: "Non, j'ajouterai manuellement",
  or_discover_new: '+ Ou découvrir un nouvel endroit',
  select: 'Sélectionner',
  add: 'Ajouter',
  freeform_cta: 'Autre chose — je vais décrire',
};

export default fr;
